module.exports = __webpack_public_path__ + "img/empty-discount-code.3fac2543.png";